import React from 'react';
import { Link } from '@mui/material';

/**
 * SkipLink - Accessibility component for keyboard users
 * Allows users to skip directly to main content
 * Hidden by default, visible on focus
 */
const SkipLink = () => (
  <Link
    href="#main-content"
    sx={{
      position: 'absolute',
      left: '-9999px',
      top: 'auto',
      width: '1px',
      height: '1px',
      overflow: 'hidden',
      zIndex: 9999,
      '&:focus': {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 'auto',
        height: 'auto',
        padding: 2,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        fontWeight: 600,
        textDecoration: 'none',
        outline: '2px solid',
        outlineColor: 'secondary.main',
        outlineOffset: 2,
      },
    }}
  >
    Skip to main content
  </Link>
);

export default SkipLink;
